module.exports = __webpack_public_path__ + "img/industryBG2.dd752be0.png";